import BaseComponent from "@js/components/base_component.jsx";
import EuiIndexSearchBar from "@js/components/eui/index_search_bar.jsx";
import EuiReceivingDomainsIndexTable from "@js/components/eui/receiving_domains/index_table.jsx";

class EuiReceivingDomainsIndex extends BaseComponent {

  render() {
    const table = this.props.receiving_domains;
    const filtered = !!( this.props.q || this.props.dns_state );

    return (
      <div>
        <EuiIndexSearchBar
          q={ this.props.q }
          placeholder={ I18n.t("phrases.search_receiving_domains") }
          indexPath={ Routes.eui_receiving_domains_path }
          filters={ [
            {
              name: "dns_state",
              value: this.props.dns_state,
              blankLabel: I18n.t("blank_options.dns_state"),
              options: [
                { value: "not_verified", label: I18n.t("dns_state_filters.not_verified") },
                { value: "verified_good", label: I18n.t("dns_state_filters.verified_good") },
                { value: "verified_regressed", label: I18n.t("dns_state_filters.verified_regressed") },
              ],
            },
          ] }
        />

        <Panel heading="receiving_domains">
          <EuiReceivingDomainsIndexTable
            table={ table && table.data }
            library={ this.props.library }
            filtered={ filtered }
          />
          {table && table.total > 0 && <Paginator entity={table} />}
        </Panel>
      </div>
    );
  }

}

export default EuiReceivingDomainsIndex;
